import React from 'react';
import {
  FormLabel,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
  Stack,
  styled,
  switchClasses,
} from '@mui/material';

const StyledSwitch = styled(MuiSwitch)(({ theme }) => ({
  [`&.${switchClasses.root}`]: {
    borderRadius: '9999px',
    padding: '0px',
  },
  [`& .${switchClasses.switchBase}`]: {
    color: '#FFF',
  },
  [`& .${switchClasses.switchBase}.${switchClasses.checked}`]: {
    color: '#FFF',
  },
  [`& .${switchClasses.switchBase}.${switchClasses.disabled}`]: {
    color: theme.custom.colours?.grey100,
  },
}));

type SwitchProps = Pick<
  MuiSwitchProps,
  'size' | 'disabled' | 'onChange' | 'checked' | 'sx' | 'slotProps' | 'name' | 'id'
>;

export const Switch: React.FC<SwitchProps> = (props) => {
  return <StyledSwitch {...props} slotProps={{ input: { role: 'switch' } }} />;
};

type SwitchWithLabelProps = SwitchProps & {
  /**
   * Label for the switch
   */
  label: string;
  /**
   * Otional sub label
   */
  subLabel?: string;
  /**
   * Id for the switch
   */
  id?: string;
};

export const SwitchWithLabel: React.FC<SwitchWithLabelProps> = (props) => {
  const { label, subLabel, id, ...rest } = props;

  return (
    <Stack direction="row" gap="8px">
      <Switch {...rest} id={id} />
      <Stack direction="column">
        <FormLabel
          sx={{ color: '#414651', fontSize: '14px', fontWeight: 500, lineHeight: '20px', marginTop: '3px' }}
          htmlFor={id}
        >
          {label}
        </FormLabel>
        {subLabel && (
          <FormLabel sx={{ color: '#535862', fontSize: '14px', fontWeight: 400, lineHeight: '20px' }}>
            {subLabel}
          </FormLabel>
        )}
      </Stack>
    </Stack>
  );
};
